import { jsx as r } from "react/jsx-runtime";
import { TradeInProvider as e } from "@perxis-auto/trade-in-sdk";
function m(n) {
  return function(o) {
    return /* @__PURE__ */ r(e, { children: /* @__PURE__ */ r(n, { ...o }) });
  };
}
export {
  m as withTradeInProvider
};
